import * as SessionStorageWrapper from "./SessionStorageWrapper";

/**
 * HL-12631: the cancellation link support generates in BO ends with `?src=support_link`.
 * Kept for the tab so it survives the login in between (Google login returns to My Orders without the URL),
 * and sent with the cancellation request, whose Mixpanel events carry it as `source`.
 */
const STORAGE_KEY = "cancellation_flow_source";
const SUPPORT_LINK = "support_link";

export const rememberCancellationFlowSource = () => {
  if (new URLSearchParams(window.location.search).get("src") === SUPPORT_LINK) {
    SessionStorageWrapper.setItem(STORAGE_KEY, SUPPORT_LINK);
  }
};

export const getCancellationFlowSource = (): typeof SUPPORT_LINK | undefined =>
  SessionStorageWrapper.getItem(STORAGE_KEY) === SUPPORT_LINK ? SUPPORT_LINK : undefined;
